import * as React from "react";
// import video1 from './assets/technology.mp4'
import "./assets/styles.css";
import NavBar from "./navbar";
import hologram from "./assets/hologram.png";

// styles
const imgStyle = {
  color: "#232129",
  padding: 10,
  width: "100%",
  fontFamily: "-apple-system, Roboto, sans-serif, serif",
};
const footerStyle = {
  textAlign: "center",
  color: "#716969",
  fontSize: 10,
};

const pageStyles = {
  color: "#232129",
  backgroundColor: "#ffffff",
  padding: 0,
  // height: "100%",
  fontFamily: "-apple-system, Roboto, sans-serif, serif",
};

const IndexPage = () => {
  return (
    <main style={pageStyles}>
      <title>Cogni-Trax</title>
      <NavBar />
      <div className="content">
        <img src={hologram} style={imgStyle} alt="Hologram in Black!" />
      </div>
      <div id="footer" style={footerStyle}>
        <h3> ceo@cogni-trax.com </h3>
        <p className="copyright">&copy; Cogni-Trax </p>
      </div>
    </main>
  );
};

export default IndexPage;
